import { render, staticRenderFns } from "./FormParking.vue?vue&type=template&id=1470b165&scoped=true"
import script from "./FormParking.vue?vue&type=script&lang=js"
export * from "./FormParking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470b165",
  null
  
)

export default component.exports